import inventoryText, {
  inventoryLocalizedName,
} from "../inventoryI18n.js";
import React, { useState, useEffect, useContext } from "react";
import { API_URL } from "../../components/api";
import "bootstrap/dist/css/bootstrap.css";
import Axios from "axios";
import Select from "react-select";
import AuthContext from "../../context/AuthContext";

function EditService(props) {
  function refreshPage() {
    window.location.reload(false);
  }

  const [message, setMessage] = useState(null);

  let { user } = useContext(AuthContext);
  let authTokens = JSON.parse(localStorage.getItem("authTokens"));
  const [name, setname] = useState("");
  const [description, setdescription] = useState("");
  const [code, setcode] = useState("");
  const [cost, setcost] = useState("");
  const [price, setprice] = useState("");
  const [reportCategory, setReportCategory] = useState("");
  const [accountHolder, setAccountHolder] = useState("");
  const [accountHolders, setAccountHolders] = useState([]);
  const [returnProduct, setReturnProduct] = useState("");
  const [returnProducts, setReturnProducts] = useState([]);
  const [isActive, setIsActive] = useState(true);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);

  useEffect(() => {
    setReportCategory(props.report_category || "");
    setAccountHolder(
      props.account_holder
        ? String(props.account_holder)
        : ""
    );
    setReturnProduct(
      props.return_product
        ? String(props.return_product)
        : ""
    );
    setIsActive(props.is_active !== 0 && props.is_active !== false);
  }, [
    props.service_id,
    props.report_category,
    props.account_holder,
    props.return_product,
    props.is_active,
  ]);

  useEffect(() => {
    const fetchHolders = async () => {
      try {
        const response = await Axios.get(
          `${API_URL}/inventory/warehouses/`,
          {
            headers: {
              Authorization: `Bearer ${authTokens.access}`,
            },
            params: {
              username: user.username,
              type: "account_holders",
            },
          }
        );

        if (response.status === 200) {
          setAccountHolders(response.data);
        }
      } catch (error) {
        console.error(error);
      }
    };

    const fetchRole = async () => {
      try {
        const response = await Axios.get(
          `${API_URL}/administration/groups/`,
          {
            headers: {
              Authorization: `Bearer ${authTokens.access}`,
            },
            params: { username: user.username },
          }
        );

        if (response.status === 200) {
          setIsSuperAdmin(response.data === "yes");
        }
      } catch (error) {
        console.error(error);
      }
    };

    const fetchReturnProducts = async () => {
      try {
        const response = await Axios.get(
          `${API_URL}/inventory/products/`,
          {
            headers: {
              Authorization: `Bearer ${authTokens.access}`,
            },
            params: {
              username: user.username,
            },
          }
        );

        if (response.status === 200) {
          setReturnProducts(response.data);
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchHolders();
    fetchReturnProducts();
    fetchRole();
  }, [user.username]);
  const [cat, setcat] = useState([]);

  const showMessage = (message, type = "success") => {
    setMessage({ text: message, type });

    // Close the modal after 3 seconds
    setTimeout(() => {
      refreshPage();
    }, 1200);

    // Clear the message after 5 seconds
    setTimeout(() => {
      setMessage(null);
    }, 1000);
  };

  let handleSubmit = async (e) => {
    e.preventDefault();
    Axios.post(
      `${API_URL}/inventory/services/`,
      {
        Action: "Put",
        service: props.service_id,
        name: name,
        description: description,
        code: code,
        cost: cost,
        price: price,
        report_category: reportCategory,
        account_holder: accountHolder,
        return_product: returnProduct,
        ...(isSuperAdmin ? { is_active: isActive } : {}),
        userdealer: user.username,
      },
      {
        headers: {
          Authorization: `Bearer ${authTokens.access}`,
        },
      }
    )
      .then((response) => {
        console.log(response);
        showMessage("Creation successful!", "success"); // Show the success message
      })
      .catch((error) => {
        console.log(error);
        showMessage("Creation failed!", "danger"); // Show the error message
      });
  };

  return (
    <div className="testi">
      <div className="mod">
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>{inventoryText("inventory.Name")}:<input
                className="form-control"
                type="text"
                value={name}
                placeholder={props.name}
                onChange={(e) => setname(e.target.value)}
              />
            </label>
            <label>{inventoryText("inventory.Description")}:<input
                className="form-control"
                type="text"
                value={description}
                placeholder={props.description}
                onChange={(e) => setdescription(e.target.value)}
              />
            </label>
          </div>
          <div className="form-group">
            <label>{inventoryText("inventory.Code")}:<input
                className="form-control"
                type="text"
                value={code}
                placeholder={props.code}
                onChange={(e) => setcode(e.target.value)}
              />
            </label>
            <label>{inventoryText("inventory.AccountHolder")}:<select
                className="form-control"
                value={accountHolder}
                onChange={(e) =>
                  setAccountHolder(e.target.value)
                }
              >
                <option value="">{inventoryText("inventory.Select")}</option>
                {accountHolders.map((holder) => (
                  <option
                    key={holder.account_holder_id}
                    value={holder.account_holder_id}
                  >
                    {inventoryLocalizedName(
                      holder.name_en,
                      holder.name_ar
                    )}
                  </option>
                ))}
              </select>
            </label>
            <label>{inventoryText("inventory.ReturnProduct")}:<select
                className="form-control"
                value={returnProduct}
                onChange={(e) =>
                  setReturnProduct(e.target.value)
                }
              >
                <option value="">{inventoryText("inventory.Select")}</option>
                {returnProducts.map((product) => (
                  <option
                    key={product.product_id}
                    value={product.product_id}
                  >
                    {product.name}
                  </option>
                ))}
              </select>
            </label>
          </div>

          <label>{inventoryText("inventory.Cost")}:<input
              className="form-control"
              type="number"
              step="0.0001"
              min="0"
              value={cost}
              placeholder={props.cost}
              onChange={(e) => setcost(e.target.value)}
            />
          </label>
          <label>{inventoryText("inventory.Price")}:<input
              className="form-control"
              type="number"
              step="0.0001"
              min="0"
              value={price}
              placeholder={props.price}
              onChange={(e) => setprice(e.target.value)}
            />
          </label>

          <label>{inventoryText("inventory.ReportCategory")}:<select
              className="form-control"
              value={reportCategory}
              required
              onChange={(e) =>
                setReportCategory(e.target.value)
              }
            >
              <option value="">{inventoryText("inventory.Unclassified")}</option>
              <option value="Account">{inventoryText("inventory.Account")}</option>
              <option value="Fee">{inventoryText("inventory.Fee")}</option>
              <option value="Contract">{inventoryText("inventory.Contract")}</option>
              <option value="VAT">{inventoryText("inventory.VAT")}</option>
              <option value="Product">{inventoryText("inventory.ProductCategory")}</option>
              <option value="Resellers">{inventoryText("inventory.Resellers")}</option>
            </select>
          </label>

          {isSuperAdmin && (
            <label>{inventoryText("inventory.Active")}:<input
                className="form-check-input"
                type="checkbox"
                checked={isActive}
                onChange={(e) =>
                  setIsActive(e.target.checked)
                }
              />
            </label>
          )}

          <div className="fo">
            <button
              type="submit"
              className="btn btn-primary btn-md"
              disabled={!reportCategory}
            >{inventoryText("inventory.Edit")}</button>
          </div>
        </form>
      </div>
      {/* Popup Message */}
      {message && (
        <div
          className={`alert alert-${message.type} alert-dismissible fade show`}
          role="alert"
          style={{
            position: "fixed",
            bottom: "10px",
            margin: "10px",
            right: "10px",
            zIndex: "9999",
          }}
        >
          {message.text}
        </div>
      )}
    </div>
  );
}

export default EditService;
